export default __webpack_public_path__ + "static/media/rangeSad.22a5c49a.svg";